/**
 * 오디오가 붙어 있는 문항만 남긴다.
 *
 * 오디오 모듈과 타이핑 모듈은 문항마다 new Audio(item.audio.path) 를 만드는데,
 * item.audio 가 null 인 문항이 하나라도 섞이면 map 전체가 예외로 끝나
 * 응답 자체가 버려지고 학습이 시작되지 않는다.
 * 재생할 소리가 없는 문항은 이 모듈들에서 진행이 불가능하므로 목록에서 제외한다.
 */
export const withAudioOnly = (questions) => {
  if (!Array.isArray(questions)) {
    return [];
  }

  const playable = questions.filter(
    (item) => item && item.audio && item.audio.path
  );

  if (playable.length !== questions.length) {
    console.warn(
      `[questions] 오디오가 없는 문항 ${
        questions.length - playable.length
      }개를 제외했습니다.`
    );
  }

  return playable;
};
